import { generateDialogParams } from '@/lib/generic.utils'
import { DataService } from '@api/index'

const SERVICE = new DataService('meta-data-categories')

export default {
  getAll(context) {
    return new Promise(resolve => {
      return SERVICE.get().then(response => {
        context.commit('updateAll', response.data.result)
        resolve(response)
      })
    })
  },
  getSingle(context, params) {
    return new Promise(resolve => {
      return SERVICE.get(params).then(response => {
        context.commit('updateSingle', response.data.result)
        resolve(response)
      })
    })
  },
  deleteConfirmation(context, params) {
    return new Promise((resolve, reject) => {
      return SERVICE.getDeleteConfirmation(params)
        .then(response => {
          context.commit(
            'updateGlobalDialogContent',
            generateDialogParams(params.dialogUid, 'deleteSingle', response.data),
            { root: true }
          )
          context.commit('updateGlobalDialogVisibility', { uid: params.dialogUid, value: true }, { root: true })
          resolve(response)
        })
        .catch(err => {
          reject(err)
        })
    })
  },
  deleteSingle(context, params) {
    return new Promise((resolve, reject) => {
      return SERVICE.delete(params)
        .then(response => {
          context.dispatch('getAll')
          resolve(response)
        })
        .catch(err => {
          reject(err)
        })
    })
  },
  create(context, params) {
    return new Promise(resolve => {
      return SERVICE.create(params).then(response => {
        resolve(response.data.result)
      })
    })
  },
  update(context, params) {
    return SERVICE.update(params)
      .then(response => response.data.result)
      .catch(err => err)
  }
}
